function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            items: {},
            reporter: {},
            reporterType: '',
            reporterName: '',
            assignee: this.getDefaultSelection(),
            assigneeType: '',
            assigneeName: '',
            reporterContactInfo: {},
            reportable: {},
            reportableType: '',
            reportableContactInfo: [],
            loading: true,
            desc: [],
            imageBlob: '',
            description: '',
            image: [],
            vendors: [],
            users: [],
            isLoading: false,
            editNotes: false,
            emptyNotes: false,
            audit: {
                user: {
                    full_name: ''
                }
            },
            priorityOptions: [{ value: 4, label: 'Urgent' }, { value: 3, label: 'High' }, { value: 2, label: 'Medium' }, { value: 1, label: 'Low' }],
            selectedPriority: '',
            serviceStatus: ['Pending', 'In Progress'],
            validations: [{ model: 'assignee.value', rules: 'required | string' }],
            notesValidation: [{ model: 'items.notes', rules: 'required' }]
        };
    },
    created: function created() {
        var _this = this;

        this.$initValidator();
        Event.$on('view-service', this.viewService);

        axios.get('/prototype/users/all').then(function (response) {
            _this.users = response.data;
        });

        axios.get('/prototype/vendors/all').then(function (response) {
            _this.vendors = response.data;
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-service');
    },

    computed: {
        priority: function priority() {

            switch (this.items.priority) {
                case 4:
                    return 'Urgent';
                    break;
                case 3:
                    return 'High';
                    break;
                case 2:
                    return 'Medium';
                    break;
                case 1:
                    return 'Low';
                    break;
                default:
                    return 'Not identified';
                    break;
            }
        },
        assigneeSelect: function assigneeSelect() {
            var users = this.users.map(function (u) {
                return {
                    label: u.first_name + ' ' + u.last_name + ' (User)',
                    value: 'user:' + u.id
                };
            });

            var vendors = this.vendors.map(function (v) {
                return {
                    label: v.name + ' (Vendor)',
                    value: 'vendor:' + v.id
                };
            });

            return [].concat(_toConsumableArray(users), _toConsumableArray(vendors));
        }
    },
    methods: {
        viewService: function viewService(ServiceId) {
            var _this2 = this;

            var $el = this;
            $el.$children[0].$data.showModal = true;
            $el.ServiceId = ServiceId;
            $el.loading = true;
            $el.assigneeName = '';
            $el.assignee = this.getDefaultSelection();
            axios.get('/prototype/service-requests?id=' + ServiceId).then(function (response) {
                $el.items = response.data.service;
                $el.audit = response.data.audit;
                $el.emptyNotes = !$el.items.notes;
                $el.desc = $el.items.service_request_desc;
                $el.selectedPriority = $el.items.priority ? _this2.getPriorityOptions().filter(function (_ref) {
                    var value = _ref.value;
                    return value === $el.items.priority;
                })[0] : $el.items.priority;
                $el.loading = false;

                // Reporter
                $el.reporter = $el.items.reporter;
                $el.reporterType = $el.items.reporter.user_id || $el.items.reporter.dwolla_status ? 'User' : 'Resident';
                if ($el.items.reporter.user_id || $el.items.reporter.dwolla_status) {
                    $el.reporterName = $el.items.reporter.full_name;
                    $el.reporterContactInfo = {
                        name: $el.items.reporter.full_name,
                        phone: $el.items.reporter.phone,
                        email: $el.items.reporter.email
                    };
                } else {
                    $el.reporterName = $el.items.reporter.person.first_name + ' ' + $el.items.reporter.person.last_name;
                    $el.reporterContactInfo = {
                        name: $el.items.reporter.person.first_name + ' ' + $el.items.reporter.person.last_name,
                        phone: $el.items.reporter.person.phone,
                        email: $el.items.reporter.person.email
                    };
                }

                // Assignee
                if ($el.items.assignee) {

                    $el.assigneeType = $el.items.assignee.name ? 'Vendor' : 'User';

                    $el.assignee = { 'label': $el.items.assignee.first_name + ' ' + $el.items.assignee.last_name, 'value': $el.assigneeType + ':' + $el.items.assignee.id };

                    $el.assigneeName = $el.items.assignee.name || $el.items.assignee.first_name + ' ' + $el.items.assignee.last_name;
                }

                // Reportable
                $el.reportable = $el.items.reportable;

                switch ($el.items.reportable_type) {
                    case 'App\\Unit':
                        $el.reportableType = 'Unit';
                        break;
                    case 'App\\Building':
                        $el.reportableType = 'Building';
                        break;
                    case 'App\\Property':
                        $el.reportableType = 'Property';
                        break;
                }

                $el.reportableContactInfo = $el.items.reportable.residents;
            });
        },
        getFile: function getFile(filename) {
            return process.env.MIX_AWS_URL + '/' + filename;
        },
        exportPDF: function exportPDF() {
            window.open('/prototype/service-requests-export?id=' + this.items.id, '_blank');
        },
        editRequest: function editRequest() {
            Event.$emit('close-full-modal', 'service-request-details');
            Event.$emit('edit-service-request', this.items);
        },

        inputImage: function inputImage(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            // Create a blob field
            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
                newFile.thumb = newFile.blob;
                this.imageBlob = newFile.file;
            }
        },
        close: function close() {
            Event.$emit('close-full-modal', 'service-request-details');
        },
        changeStatus: function changeStatus() {
            var $el = this;
            axios.get('/prototype/service-requests/closeService?id=' + $el.ServiceId).then(function (response) {
                $el.$snotify.success('The service request was closed');
                Event.$emit('close-full-modal', 'service-request-details');
                Event.$emit('refresh-service', response, 'close');
                Event.$emit('refresh-service-requests');
            });
        },
        updateRequest: function updateRequest() {
            this.validator.setRules(this.validations).validate();

            if (this.validator.fails()) {
                return;
            }

            var assignee = this.assignee.value.split(':');

            this.items.priority = this.selectedPriority;
            this.items.assignee_type = assignee[0];
            this.items.assignee_id = assignee[1];

            axios.put('/prototype/service-requests/update', this.items).then(function (response) {
                Event.$emit('refresh-service', response, 'open');
                Event.$emit('refresh-service-requests');
                Event.$emit('close-full-modal', 'service-request-details');
            });
        },
        addNotes: function addNotes() {
            var _this3 = this;

            this.validator.setRules(this.notesValidation).validate();

            if (this.validator.fails()) {
                return;
            }
            this.loading = true;
            this.isLoading = true;
            axios.post('/prototype/service-request-add-notes', this.items).then(function (response) {
                _this3.audit = response.data.audit;
                _this3.editNotes = false;
                _this3.loading = false;
                _this3.isLoading = false;
                _this3.emptyNotes = false;
            });
        },
        getPriorityOptions: function getPriorityOptions() {
            return [{ value: 4, label: 'Urgent' }, { value: 3, label: 'High' }, { value: 2, label: 'Medium' }, { value: 1, label: 'Low' }];
        },
        getDefaultSelection: function getDefaultSelection() {
            return {
                label: "",
                value: ""
            };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/ServiceRequestDetail.vue
// module id = lG7D
// module chunks = 0 1